/*
 * Copyright (c) 2026 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Sunday, June 14th 2026, 10:47:50 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

const BOUNDARY_EVENT_NODE_SIZE = 28;
const BOUNDARY_EVENT_START_POSITION = 15;

export { BOUNDARY_EVENT_NODE_SIZE, BOUNDARY_EVENT_START_POSITION };
